/**
 * Load a classic (non-module) script once. Vendored geoxml3 / ProjectedOverlay
 * rely on sloppy-mode implicit globals and must not be evaluated as ESM.
 *
 * @param {string} url
 * @param {() => boolean} isReady
 * @returns {Promise<void>}
 */
export function loadClassicScript(url, isReady) {
	if (typeof isReady === 'function' && isReady()) {
		return Promise.resolve();
	}

	const existing = document.querySelector(`script[data-swa-classic-src="${url}"]`);
	if (existing) {
		return new Promise((resolve, reject) => {
			const started = Date.now();
			const timer = setInterval(() => {
				if (typeof isReady === 'function' && isReady()) {
					clearInterval(timer);
					resolve();
				} else if (Date.now() - started > 15000) {
					clearInterval(timer);
					reject(new Error(`Timed out loading classic script: ${url}`));
				}
			}, 50);
		});
	}

	return new Promise((resolve, reject) => {
		const script = document.createElement('script');
		script.src = url;
		script.async = false;
		script.dataset.swaClassicSrc = url;
		script.onload = () => {
			if (typeof isReady === 'function' && !isReady()) {
				reject(new Error(`Classic script loaded but globals missing: ${url}`));
				return;
			}
			resolve();
		};
		script.onerror = () => {
			script.remove();
			reject(new Error(`Failed to load classic script: ${url}`));
		};
		document.head.appendChild(script);
	});
}
